export const pillars = ['Hangeul', 'Aussprache', 'Wortschatz', 'Routine'];

export const volumes = [
  {
    n: 1,
    emoji: '🧩',
    title: 'Hangeul ohne Komplikationen erklärt',
    desc: 'Verstehe, wie das koreanische Alphabet funktioniert, klar und Schritt für Schritt, damit du selbstbewusst lesen und schreiben kannst — auch wenn du noch nie Koreanisch studiert hast.',
  },
  {
    n: 2,
    emoji: '🎤',
    title: 'Grundaussprache, die wirklich richtig klingt',
    desc: 'Lerne die wesentlichen Laute zu produzieren und vermeide die häufigsten Fehler, die Deutschsprachige machen, auch wenn du noch nie eine Sprache studiert hast.',
  },
  {
    n: 3,
    emoji: '🗣️',
    title: 'Echte Sätze und alltägliche Ausdrücke',
    desc: 'Integriere das wesentliche Vokabular und Ausdrücke, die wirklich in K-Dramen erscheinen, damit du die Sprache in echten Situationen ab der ersten Woche nutzen kannst.',
  },
  {
    n: 4,
    emoji: '📅',
    title: '60-Minuten-Routine mit sichtbarem Fortschritt',
    desc: 'Folge einem einfachen Plan, um voranzukommen, ohne dich zu verlaufen, messe deinen Fortschritt mit klaren Schritten und halte deine Motivation bis Tag 60 hoch.',
  },
  {
    n: 5,
    emoji: '🎬',
    title: 'Verstehe K-Dramen & K-Pop (endlich)',
    desc: 'Am Ende von 60 Minuten verstehst du bereits 30-40% des Dialogs ohne Untertitel und verstehst die Songtexte wie nie zuvor.',
  },
  {
    n: 6,
    emoji: '💬',
    title: 'Triff die K-Community mit Selbstvertrauen',
    desc: 'Knüpfe echte Freundschaften mit Koreanern, nimm an Fan-Gemeinschaften teil und führe dein erstes echtes Gespräch auf Koreanisch, ohne zu erstarren.',
  },
];

export const volumeIncludes = [
  'Visuelle Lektionen Schritt für Schritt',
  'Romanisierung + Übersetzung',
  'Ausspracheübungen',
  'Echte Beispiele aus K-Dramas',
  'Checklisten für tägliche Praxis',
  'Druckbare Prüfungsblätter',
  'Für absolute Anfänger konzipiert',
  'Ab heute anwendbar',
];

export const bonuses = [
  {
    n: '01',
    title: 'Hangeul-Turbo-CheatSheet™ 📖',
    desc: 'Lerne das koreanische Alphabet in nur 24 Stunden. Dieses visuelle Cheat-Sheet zeigt dir die Logik hinter jedem Buchstaben, damit du Hangeul nicht einfach auswendig lernst, sondern wirklich verstehst. Mit Mini-Quizzen und Leseübungen. Nach diesem Bonus kannst du bereits koreanische Menüs und Schilder lesen.',
    price: '25€',
  },
  {
    n: '02',
    title: 'K-Vokabel-Tracker™ 📊',
    desc: 'Dein persönliches 30-Tage-Erfolgstagebuch. Ein PDF-Planer mit Wochenzielen, Fortschritts-Checkpoints und Motivations-Triggern. Vermeide das Vergessen mit der Ebbinghaus-Kurve und sieh täglich, wie du deinem Ziel näher kommst. Strukturiert, wissenschaftlich und einfach zu nutzen.',
    price: '25€',
  },
  {
    n: '03',
    title: 'K-Reise-Guide™ 🗺️',
    desc: 'Dein Survival-Guide für Seoul. Lerne echte Sätze für das Reisen: im Restaurant, im Hotel, in der U-Bahn, beim Shopping. Mit kulturellen Tipps, Adress-Listen und Ausdrücken, die du wirklich brauchen wirst. Perfekt, um dein erstes Abenteuer in Korea zu planen und die Sprache live zu nutzen.',
    price: '27€',
  },
  {
    n: '04',
    title: 'K-Visual Flashcards™ 🎨',
    desc: '200+ visuelle Lernkarten zum Ausdrucken oder digital nutzen. Jede Karte zeigt ein Bild mit dem koreanischen Wort, der Romanisierung und einem Beispiel. Ideal zum Mitnehmen, Durchblättern und schnellen Wiederholen. Perfekt für Vokabeltraining unterwegs.',
    price: '20€',
  },
  {
    n: '05',
    title: 'Der K-Drama Slang-Spickzettel™ 🎬',
    desc: 'Die 100 authentischen Sätze und Slang-Ausdrücke, die in JEDEM K-Drama vorkommen. Von Liebesgeständnissen bis Drama-Momenten — lerne die Sprache, die du wirklich sehen wirst. Mit formalen und informellen Varianten sowie der genauen Episode, in der sie erscheinen. Verstehe K-Dramen ECHT zum ersten Mal.',
    price: '19€',
  },
];
